import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { openWhatsApp, WHATSAPP_MESSAGES } from "@/lib/whatsapp";
import { OptimizedPicture } from "@/components/OptimizedPicture";

export const CTASection = () => {
  const { language, translations } = useLanguage();
  const t = translations?.ctaSection;

  if (!t) return null;

  return (
    <section className="relative py-20 px-4 overflow-hidden">
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
        className="absolute inset-0"
      >
        <OptimizedPicture
          src="/lovable-uploads/bosque-rocas-musgo.png"
          alt="Children walking up mossy rocks in the forest"
          width={1200}
          height={800}
          loading="lazy"
          decoding="async"
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary/80 to-primary/60" />
      </motion.div>

      <div className="container mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center space-y-6"
        >
          <h2 className="text-3xl md:text-4xl font-light text-primary-foreground">
            {t.title}
          </h2>
          <p className="text-lg md:text-xl text-primary-foreground/90 max-w-2xl mx-auto">
            {t.subtitle}
          </p>
          
          <div className="flex justify-center pt-6">
            <motion.button
              onClick={() => openWhatsApp(WHATSAPP_MESSAGES.bookVisit[language])}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-primary-foreground text-primary px-8 py-4 rounded-lg font-medium hover:bg-primary-foreground/90 transition-colors duration-200 flex items-center gap-2 shadow-lg"
            >
              <MessageCircle className="w-5 h-5" />
              {t.bookVisit}
            </motion.button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
